import axios from 'axios'

let getCookie = (cname) => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(name,value,days) {

  var expires = "";
  var domain = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();

    if(window.location.hostname.indexOf('eduaid') > -1) {
      domain = '; domain=.eduaid.ir';
    } else {
      domain = '';
    }
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/" + domain;

}

if (!getCookie("kand")) {
  let randNumber = Math.ceil(Math.random() * 1000);
  let randNumber2 = Math.ceil(Math.random() * 1000);
  setCookie("kand", new Date().getTime() + randNumber - randNumber2);
}

let dataurl = getCookie('kand');

const instance = axios.create({
  baseURL: `/core/api/curl/2.php?fill=${dataurl}&url=`,
  headers: { 'Content-Type': 'application/json' },
});
export default instance

